import React from 'react';
import { useCssHandles } from '../utils/functions';
import { useSelector } from 'react-redux';
import { selectMockImages } from '../redux/mockImagesSlice';
//import sass file
import './MockAutocomplete.scss';
const CSS_HANDLES = [
	'portalContainer',
	'portalWrapper',
	'resultsList',
	'resultsItem',
	'searchTerm',
	'resultsItemName',
	'resultsItemImage',
];
const MockAutocomplete = ({ blockClass, showAutocomplete, inputValue }) => {
	const mockImages = useSelector(selectMockImages);
	const { handles } = useCssHandles(`vtex-mega-menu-2-x`, CSS_HANDLES, blockClass);

	return (
		<div>
			<div className={`${handles.portalContainer} ${handles.portalContainerWrapper}`} style={{ zIndex: 2147483647 }}>
				<div className={`flex justify-start ${handles.absoluteWrapper}`} style={{ position: 'absolute', left: '0' }}>
					<div className="absolute">
						<div style={{ width: '517px' }}>
							{showAutocomplete && (
								<ul
									className={`${handles.resultsList} z-max w-100 bl-ns bb br-ns bw1 b--muted-4 bg-base c-on-base t-body left-0 list pv4 ph0 mv0 list overflow-y-auto absolute`}
									role="listbox"
									aria-labelledby="downshift-0-label"
									id="downshift-0-menu"
								>
									<li id="downshift-0-item-0" role="option" aria-selected="false">
										<a href="/anel?map=ft" className={`pointer pa4 outline-0 ${handles.resultsItem}  db w-100`}>
											Buscar por <span className={`${handles.searchTerm}`}>"{inputValue}"</span>
										</a>
									</li>
									{['categoria1', 'categoria2', 'categoria3', 'categoria4', 'categoria5', 'categoria6'].map((item) => (
										<li id="downshift-0-item-1" role="option" aria-selected="false">
											<a href="/" className={`pointer pa4 outline-0 ${handles.resultsItem}  db w-100`}>
												<div className={`${handles.resultsItemName} flex justify-start items-center`}>termo {item}</div>
											</a>
										</li>
									))}
									{Array(5)
										.fill(0)
										.map(() => (
											<li id="downshift-0-item-7" role="option" aria-selected="false">
												<a href="/" className={`pointer pa4 outline-0 ${handles.resultsItem}  flex justify-start`}>
													<img
														src={
															mockImages?.['shelf']?.length
																? mockImages?.['shelf'][Math.floor(Math.random() * mockImages?.['shelf'].length)]
																: 'https://hefesto-upload-images.s3.amazonaws.com/1682355195484-156867-1200-auto.png'
														}
														width="50"
														height="50"
														alt="produto"
														className={`${handles.resultsItemImage} mr4 vtex-render-runtime-8-x-lazyload`}
													/>
													<div className={`${handles.resultsItemName} flex justify-start items-center`}>
														Produto {inputValue}
													</div>
												</a>
											</li>
										))}
								</ul>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MockAutocomplete;
